import ReactGA from 'react-ga4';

export const initGA = () => {
  ReactGA.initialize('G-KD380ZD6K8'); // Replace with your Measurement ID
};

export const logPageView = (path: string) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};
